import { Box, Container, Typography } from '@mui/material'
import React, { useContext } from 'react'
import ApartmentIcon from "@mui/icons-material/Apartment";
import BusinessIcon from "@mui/icons-material/Business";
import PeopleIcon from '@mui/icons-material/People';
import { apisPath } from '../../../utils/path';
import PdfIcon from "../../Images/pdf-icon.svg";
import XlsIcon from "../../Images/xls-icon.svg";
import { CommonContext } from '../../../context/CommonContext';
import { downloadBlob } from '../../../helpers/commonHelper';
import { authHttp } from '../../../services/commonHttpService';
import dayjs from 'dayjs';
import { executeDownload } from '../../../helpers/commonHelper';
import DashboardCards from '../../../shared/DashboardCards/DashboardCards';
import SummarizeIcon from '@mui/icons-material/Summarize';

const AdminReportsDownload = () => {
    const { setIsLoading, setSnackState } = useContext(CommonContext);

    const cardConfig = [
        {
            id: 1,
            title: "TCCC Lists",
            icon: <BusinessIcon sx={{ color: "#6C7FF9" }} />,
            isReportMaster: true,
            facilityType: "MI",
        },
        {
            id: 2,
            title: "TCCC Wise Report",
            icon: <PeopleIcon sx={{ color: "#6C7FF9" }} />,
            isReportMaster: false,
            level: 1,
            facilityType: "MI",
        },
        {
            id: 3,
            title: "DCCC Lists",
            icon: <ApartmentIcon sx={{ color: "#6C7FF9" }} />,
            isReportMaster: true,
            facilityType: "DCCC",
        },
        {
            id: 4,
            title: "DCCC State Summary Report",
            icon: <SummarizeIcon sx={{ color: "#6C7FF9" }} />,
            isDCCCStateSummary: true,
            facilityType: "DCCC",
        }
    ];

    const generateButtons = (card) => {
        const createBtn = (format, label, icon) => ({
            label,
            icon,
            className: "dwnBtnAdmin",
            onClick: () => {
                let fileName = "";
                let apiPath = "";
                let params = { type: format === 'pdf' ? 'pdf' : 'excel' };

                if (card.isReportMaster) {
                    fileName = `${card.facilityType === "MI" ? "TCCC" : "DCCC"}_LineList_Report_${dayjs().format("YYYY-MM-DD")}.${format === 'pdf' ? 'pdf' : 'xlsx'}`;
                    apiPath = apisPath?.reports?.reportsMaster;
                    params = { ...params, facility_type: card.facilityType, state_lgd: "0" };
                } else if (card.isDCCCStateSummary) {
                    fileName = `${card.facilityType === "MI" ? "TCCC" : "DCCC"}_All_State_Summary_Report_${dayjs().format("YYYY-MM-DD")}.${format === 'pdf' ? 'pdf' : 'xlsx'}`;
                    apiPath = apisPath?.reports?.getDCCCSummaryReport;
                    params = { ...params, state_lgd: "0" };
                } else {
                    fileName = `${card.facilityType === "MI" ? "TCCC" : "DCCC"}_Wise_Report_${dayjs().format("YYYY-MM-DD")}.${format === 'pdf' ? 'pdf' : 'xlsx'}`;
                    apiPath = apisPath?.reports?.getTCCCReport;
                    params = { ...params, level: card.level };
                }

                executeDownload(apiPath, params, fileName, setIsLoading, setSnackState);
            }
        });

        return [
            // createBtn('pdf', "Download PDF", PdfIcon),
            createBtn('excel', "Download Excel", XlsIcon)
        ];
    };

    const dashboardCards = cardConfig.map(card => ({
        ...card,
        buttons: generateButtons(card)
    }));

    return (
        <>
            <Box
                sx={{
                    width: "100%",
                    backgroundColor: "#FFFFFF",
                    borderBottom: "1px solid #E6E6E6", // light grey line
                    py: 2,
                }}
            >
                <Container>
                    {/* Title */}
                    <Typography variant="h6" fontWeight="600">
                        Day Care Cancer Center
                    </Typography>

                    {/* Subtitle */}
                    <Typography variant="body2" color="gray" sx={{ mt: 0.3 }}>
                        State Cancer Care Program - Comprehensive Overview
                    </Typography>
                </Container>
            </Box>
            <Container>
                <Typography variant="h6" fontWeight={600} className="mt-3">
                    National Overview
                </Typography>

                <DashboardCards cards={dashboardCards} />
            </Container>
        </>
    )
}

export default AdminReportsDownload